module.exports = __webpack_public_path__ + "static/media/triangle_blue.e8732f96.svg";